export default __webpack_public_path__ + "static/media/Image-2.4c8a3683.png";